<template>
  <a-modal
    :title="'发送'+title"
    :visible="dialogVisible"
    :footer="null"
    width="650px"
    @cancel="clickCancel">
    <a-form-model
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      :label-col="{span:5}"
      :wrapper-col="{span:19}"
    >
      <a-form-model-item label="手机号码" style="margin-bottom: 0" prop="phone">
        <a-input v-model="ruleForm.phone" auto-complete="off" :maxLength="11" placeholder="请填手机号码"></a-input>
      </a-form-model-item>
      <p class="lhp">*平台抢购类自动填写手机号</p>
      <a-form-model-item label="发送短信" prop="sendFlag" style="margin-bottom: 5px">
        <a-switch checked-children="是" un-checked-children="否" v-model="ruleForm.sendFlag"/>
      </a-form-model-item>
      <a-form-model-item label="关联订单号" prop="orderNo">
        <a-input v-model="ruleForm.orderNo" auto-complete="off" placeholder="请填关联订单号"></a-input>
      </a-form-model-item>
      <a-form-model-item label="短信内容" prop="smsContent">
        <a-textarea
          v-model="ruleForm.smsContent"
          placeholder="请输入短信内容"
          :auto-size="{ minRows: 3, maxRows: 5 }"
          :maxLength="600"
        />
      </a-form-model-item>
      <a-form-model-item label="备注信息">
        <a-textarea
          v-model="ruleForm.message"
          :rows="4"
          :maxLength="100"
          placeholder="请填写备注信息"></a-textarea>
      </a-form-model-item>
      <a-form-model-item :wrapper-col="{ span: 14, offset: 6 }">
        <a-button type="primary" @click="handleSubmit" :loading="submitLoading">确定</a-button>
        <a-button style="margin-left: 10px;" @click="clickCancel">取消</a-button>
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
export default {
  name: 'couponSendMessageDialog',
  components: {},
  props: {
    title: {
      type: String,
      default: ''
    },
    visible: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    sendForm: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      submitLoading: false,
      ruleForm: {
        phone: '',
        message: '',
        orderNo: '',
        smsContent: '',
        redeemCode: '',
        couponId: '',
        sendFlag: true
      },
      rules: {
        orderNo: [
          { required: true, message: '请输入关联订单号', trigger: 'blur' }
        ],
        smsContent: [
          { required: true, message: '请输入短信内容', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号！', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    loading(val) {
      this.submitLoading = val
    },
    sendForm: {
      deep: true,
      handler(val, oldVal) {
        this.getLogUtils().logWithTag('更新', val)
        this.ruleForm = val
      }
    }
  },
  mounted() {
    this.dialogVisible = this.visible
    this.submitLoading = this.loading
    this.ruleForm = this.sendForm
  },
  computed: {},
  methods: {
    handleSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.$emit('submitData', this.ruleForm)
        } else {
          this.getLogUtils().logWithTag('error submit!!')
          return false
        }
      })
    },
    clickCancel() {
      this.$emit('cancel')
    }
  }
}
</script>

<style scoped>
.lhp {
  height: 30px;
  line-height: 30px;
  padding-left: 124px;
  margin-bottom: 0;
}
</style>